import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const DailyWater = lazyWithPreload(() => import('./DailyWater'))
export const DailyWaterVariant2 = lazyWithPreload(
  () => import('./DailyWaterVariant2'),
)
